document.addEventListener("DOMContentLoaded", function () {
  const wishlistBlock = document.querySelector(".js-wishlistBlock");
  const wishlistBlockList = document.getElementById("product-grid");
  const wishlistEmpty = document.getElementById("store-wishlist-empty-wrapper");
  const wishlistWrapper = document.getElementById("store-wishlist-wrapper");
  const wishlistLoader = document.getElementById("store-wishlist-loading-wrapper");

  if (wishlistBlock && wishlistBlock.hasAttribute("data-customer")) {
    const customerId = wishlistBlock.getAttribute("data-customer");

    if(customerId){

      // Call your WP API to get wishlist product IDs
      fetch("https://apps.gemstonesforsale.com/wp-json/wishlist/v1/list?customer_id=" + encodeURIComponent(customerId))
      .then(res => res.json())
      .then(async data => {

        if (wishlistLoader) wishlistLoader.style.display = "none";

        if (!Array.isArray(data) || data.length === 0) {
          if (wishlistEmpty) wishlistEmpty.style.display = "flex";
          return;
        }

        // Counters
        const totalProducts = data.length;
        let successCount = 0;
        let failedCount = 0;
        const failedHandles = [];

        // STEP: Fetch section HTML for each product (instead of product.js)
const productPromises = data.map(async (item) => {
  const productId = item.product_id;
  const productHandle = item.product_handle;

  try {
    const res = await fetch(`/products/${productHandle}?section_id=wishlist-render-products`);

    if (!res.ok) {
      failedCount++;
      failedHandles.push(productId);
      throw new Error("Product not found: " + productHandle);
    }

    const html = await res.text();
    successCount++;

    return {
      productId: productId,
      html: html
    };

  } catch (err) {
    console.warn("Skipping product", productId, err);
    return null;
  }
});

// wait all
const wishlistData = (await Promise.all(productPromises)).filter(Boolean);

        // After 1 minute, call remove API for failed handles
        if (failedHandles.length > 0) {
          setTimeout(() => {
            failedHandles.forEach(async (productId) => {
              try {
                await fetch("https://apps.gemstonesforsale.com/wp-json/wishlist/v1/remove", {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({
                    customer_id: customerId,
                    product_id: productId
                  })
                });
                console.log("Removed invalid product:", productId);
              } catch (err) {
                console.error("Failed to remove invalid product:", productId, err);
              }
            });
          }, 60 * 1000); // 1 minute
        }

        if (wishlistData.length === 0) {
          if (wishlistEmpty) wishlistEmpty.style.display = "flex";
          if (wishlistWrapper) wishlistWrapper.style.display = "none";
          return;
        }else{
          if (wishlistEmpty) wishlistEmpty.style.display = "none";
          if (wishlistWrapper) wishlistWrapper.style.display = "flex";
        }

        // wishlist stats
        document.getElementById('itemCount').innerHTML = successCount+" item added";
        document.getElementById('draftItemCount').innerHTML = failedCount+" item drafted";

        // Render HTML (your existing rendering code here)
        const wishlistBlockList = document.getElementById("product-grid");

wishlistBlockList.innerHTML = "";

// append each rendered section
wishlistData.forEach(item => {
  const temp = document.createElement("div");
  temp.innerHTML = item.html;

  // IMPORTANT: your section should return <li class="grid__item">
  const li = temp.querySelector("li.grid__item");

  if (li) {
    // attach product id for later use (wishlist remove / GTM)
    li.setAttribute("data-product-id", item.productId);

    wishlistBlockList.appendChild(li);
  }
});
      })
      .catch(err => {
        console.error("Wishlist fetch error:", err);
        wishlistBlock.innerHTML = "<p>Unable to load wishlist at the moment.</p>";
      });
    }else{
      if (wishlistEmpty) wishlistEmpty.style.display = "flex";
      if (wishlistWrapper) wishlistWrapper.style.display = "none";
      if (wishlistLoader) wishlistLoader.style.display = "none";
    }

      /* remove li from wishlist */
      // Event delegation for remove
    document.addEventListener("click", async function (e) {
      const button = e.target.closest(".wishlist_button.in");
      if (!button) return;

      const productId = button.getAttribute("data-product");
      if (!productId || !customerId) {
        console.error("Missing productId or customerId");
        return;
      }

      // Get sibling loader
      const removeAction = button.parentElement.querySelector("#wishlist-loader");

      if (removeAction) {
        button.style.display = "none";
        removeAction.style.display = "block";
      }

      try {
        const res = await fetch("https://apps.gemstonesforsale.com/wp-json/wishlist/v1/remove", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            customer_id: customerId,
            product_id: productId
          })
        });

        const data = await res.json();

        if (data.status === true) {
          // remove the <li> wrapper
          const li = button.closest("li.grid__item");
          if (li) li.remove();

          // If wishlist becomes empty → show message
          const grid = document.getElementById("product-grid");
          if (grid && grid.children.length === 0) {
            if (wishlistEmpty) wishlistEmpty.style.display = "flex";
            if (wishlistWrapper) wishlistWrapper.style.display = "none";
          }
        }
      } catch (err) {
        console.error("Wishlist remove API error:", err);
      }
    });

  }
});

document.addEventListener("DOMContentLoaded", function () {
  const actionToggles = document.querySelectorAll(".store-wishlist-actions");

  actionToggles.forEach(toggle => {
    toggle.addEventListener("click", function () {
      const actionsList = this.querySelector(".actions-list");

      if (actionsList) {
        actionsList.classList.toggle("active");
      }
    });
  });

  // select all
  const selectAllLi = document.getElementById("action-selectAll");

  if (selectAllLi) {
    selectAllLi.addEventListener("click", function () {
      const checkboxes = document.querySelectorAll(".wishlist_bulk_select");

      // check if all are already selected
      const allChecked = Array.from(checkboxes).every(cb => cb.checked);

      // toggle: if all are checked → uncheck all, else check all
      checkboxes.forEach(cb => {
        cb.checked = !allChecked;
      });

      // optional: add active class to indicate state
      selectAllLi.classList.toggle("active", !allChecked);
    });
  }

  // remove - bulk
  const removeAction = document.getElementById("action-remove");
  const wishlistBlock = document.querySelector(".js-wishlistBlock");
   const removeLoader = document.getElementById("remove-loader");

  if (removeAction && wishlistBlock) {
    removeAction.addEventListener("click", async function () {
      const customerId = wishlistBlock.getAttribute("data-customer");
      const checkedBoxes = document.querySelectorAll(".wishlist_bulk_select:checked");

      if (!customerId || checkedBoxes.length === 0) {
        alert("Please select products to remove.");
        return;
      }

      // Collect promises for all remove calls
      if (removeLoader) removeLoader.style.display = "flex";
      const removePromises = Array.from(checkedBoxes).map(cb => {
        const productId = cb.getAttribute("data-product");
        return fetch("https://apps.gemstonesforsale.com/wp-json/wishlist/v1/remove", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            customer_id: customerId,
            product_id: productId
          })
        }).then(res => res.json());
      });

      try {
        await Promise.all(removePromises); // wait for all to finish
        location.reload(); // reload once all complete
      } catch (err) {
        console.error("Error removing wishlist items:", err);
        alert("Some items could not be removed. Please try again.");
      }
    });
  }
});